import React from 'react';
import {
    KeyboardArrowRight,
    KeyboardArrowLeft,
    DateRange,
    AccessTime
} from '@material-ui/icons'
import { DateTimePicker } from 'material-ui-pickers';
import { omit } from 'ramda';

/**
 * Render custom SM date time picker with default icons, config, and timestamp formatting set by default.
 * This component will accept all standard props from material-ui-pickers DateTimePicker component.
 * Default values for props can be overridden by adding them to this component.
 * Due to the need to override the default timestamp output format, use onDateSelect instead of onChange
 * to register a callback on this component. 
 * onDateSelect will return an object containing the selected date, and the name of the input
 * @param {*} onDateSelect Callback to handle date change
 */

const defaultProps = [
    'leftArrowIcon',
    'rightArrowIcon',
    'dateRangeIcon',
    'timeIcon',
    'onDateSelect',
    'format',
    'clearable'
];

function SMDatePicker (props) {
    const customProps = omit(defaultProps, props); // remove default and custom props

    // Provide custom timestamp format required by API
    const handleDateChange = selectedDate => {
        const date = selectedDate ? selectedDate.format() : selectedDate;
        const name = props.name || '';
        return props.onDateSelect({ date, name });
    };

    return (
        <DateTimePicker
            leftArrowIcon={props.leftArrowIcon || <KeyboardArrowLeft />}
            rightArrowIcon={props.rightArrowIcon || <KeyboardArrowRight />}
            dateRangeIcon={props.dateRangeIcon || <DateRange />}
            timeIcon={props.timeIcon || <AccessTime />}
            format={props.format || "MMM D, YYYY h:mm A"}
            clearable={props.clearable || true}
            onChange={handleDateChange}
            {...customProps}
        />
    );
}

export default SMDatePicker;
